import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
  isAuthSaveSuccess: false,
  isAuthUpdateSuccess: false,
  deleteErrors : [],
  isDeleteSuccess: false,
};
const initialState = {
  ...resetState,
  isLoading: false,
  authSettingsList: {
    authSchemes: [],
  },
  isUpdateDefaultSuccess: false,
  providerNameUnique: { d: { result: true } },
  authScheme: {
    name: '',
    description: '',
    authMethod: '',
    authznType: 'IDP',
    editable: true,
    enabled: true,
    defaultConfig: false,
    logo: '',
    advancedConfigurations: { enhancedPasswordSecurity: 'no' },
    RoleMappings: {},
    ConfigurationParams: {
      baseDN: '',
      bindDN: '',
      bindPassword: '',
      hostname: '',
      ldapQueryEnd: '',
      ldapQueryStart: '',
      port: '',
      sslEnabled: 'no',
      issuerId: '',
      multiOrgRoleDelimiter: '',
      multiOrgRoleFormat: '',
      multiOrgRoleFormatMismatchAction: 'FAIL',
      orgRoleMappingType: '',
      samlBinding: '',
      samlTokenAttribute: '',
      samlTokenAttributeIn: '',
      serviceProviderId: '',
      emailDomain: '',
      acsUrl: '',
      certificateFileName: '',
      url: '',
    },
    AttributeMappings: {
      EMAIL_ATTRIBUTE: '',
      FIRST_NAME_ATTRIBUTE: '',
      LAST_NAME_ATTRIBUTE: '',
      ORGANIZATION_ATTRIBUTE: '',
      ROLE_ATTRIBUTE: '',
    },
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET: {
      return {
        ...state,
        ...resetState,
        authScheme: {
          name: '',
          description: '',
          authMethod: 'LDAP',
          authznType: 'IDP',
          editable: true,
          enabled: true,
          defaultConfig: false,
          logo: '',
          advancedConfigurations: { enhancedPasswordSecurity: 'no' },
          RoleMappings: {},
          ConfigurationParams: {
            baseDN: '',
            bindDN: '',
            bindPassword: '',
            hostname: '',
            ldapQueryEnd: '',
            ldapQueryStart: '',
            port: '',
            sslEnabled: 'no',
          },
        },
      };
    }
    case Constants.APP_LOADING:
      return {
        ...state,
        ...resetState,
        isLoading: action.isLoading,
      };
    case Constants.AUTH_SETTINGS_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        authSettingsList: action.payload,
        isUpdateDefaultSuccess: false,
      };
    case Constants.AUTH_SETTINGS_GET_LIST_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.AUTH_SETTINGS_UPDATE_DEFAULT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        isUpdateDefaultSuccess: true,
      };
    case Constants.AUTH_SETTINGS_UPDATE_DEFAULT_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
        isUpdateDefaultSuccess: false,
      };
    case Constants.AUTH_SETTINGS_NAME_UNIQUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        providerNameUnique: action.payload,
      };
    case Constants.AUTH_SETTINGS_NAME_UNIQUE_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
    case Constants.AUTH_SETTINGS_GET_SCHEMA_DETAILS_SUCCESS: {
      const configParams = { ...action.payload.authScheme.ConfigurationParams, ...{
        bindPassword: '' } };
      const details = { ...action.payload.authScheme, ...{
        ConfigurationParams: configParams } };
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        authScheme: details,
      };
    }
    case Constants.AUTH_SETTINGS_GET_SCHEMA_DETAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
    case Constants.AUTH_SETTINGS_SET_LDAP_AUTH_DETAILS: {
      const details = { ...state.authScheme, ...action.payload };
      return {
        ...state,
        isLoading: false,
        isError: false,
        authScheme: details,
      };
    }
    case Constants.AUTH_SETTINGS_SAVE_SCHEMA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isAuthSaveSuccess: true,
      };
    case Constants.AUTH_SETTINGS_SAVE_SCHEMA_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
    case Constants.AUTH_SETTINGS_UPDATE_SCHEMA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isAuthUpdateSuccess: true,
      };
    case Constants.AUTH_SETTINGS_UPDATE_SCHEMA_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
      case Constants.AUTH_SETTINGS_DELETE_SUCCESS:
        return {
          ...state,
          isLoading: false,
          deleteErrors: [],
          isDeleteSuccess: true,
        };
      case Constants.AUTH_SETTINGS_DELETE_ERROR:
        return {
          ...state,
          isLoading: false,
          isDeleteSuccess: false,
          deleteErrors: action.payload,
        };

    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'authSettings.isLoading');

export const getIsError = (state) => get(state, 'authSettings.isError');

export const getErrors = state => get(state, 'authSettings.errors');

export const getAuthSettingsListResults = (state) => get(state, 'authSettings.authSettingsList.authSchemes');

export const getIsUpdateDefaultSuccess = (state) => get(state, 'authSettings.isUpdateDefaultSuccess');

export const getIsProviderNameUnique = (state) => get(state, 'authSettings.providerNameUnique.d.result');

export const getAuthSchemeDetails = (state) => get(state, 'authSettings.authScheme');

export const getIsAuthSaveSuccess = (state) => get(state, 'authSettings.isAuthSaveSuccess');
export const getIsAuthUpdateSuccess = (state) => get(state, 'authSettings.isAuthUpdateSuccess');

export const getIsDeleteSuccess = (state) => get(state, 'authSettings.isDeleteSuccess');
export const getDeleteErrors = (state) => get(state, 'authSettings.deleteErrors');
